import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGridRegular20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconGridRegular20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 2A1.5 1.5 0 0 0 2 3.5v4A1.5 1.5 0 0 0 3.5 9h4A1.5 1.5 0 0 0 9 7.5v-4A1.5 1.5 0 0 0 7.5 2zm9 0A1.5 1.5 0 0 0 11 3.5v4A1.5 1.5 0 0 0 12.5 9h4A1.5 1.5 0 0 0 18 7.5v-4A1.5 1.5 0 0 0 16.5 2zM2 12.5A1.5 1.5 0 0 1 3.5 11h4A1.5 1.5 0 0 1 9 12.5v4A1.5 1.5 0 0 1 7.5 18h-4A1.5 1.5 0 0 1 2 16.5zM12.5 11a1.5 1.5 0 0 0-1.5 1.5v4a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGridRegular20Filled);
